import bookingConverter from 'models/Booking/converter'
import getCollectionByName from 'actions/base/getCollectionByName'

const getCollection = (withConverter = true) => getCollectionByName('bookings', withConverter ? bookingConverter : null)

export default getCollection
